<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" sm="6">
        <v-card
          color="primary"
          class="white--text text-center ml-auto"
          width="400"
          height="375"
          @click="$emit('blank')"
        >
          <div class="image-container">
            <v-img
              contain
              :src="$images.SURVEY_SCRATCH"
              height="150"
              class="ma-auto"
            ></v-img>
          </div>
          <v-card-title class="d-block white--text">
            Start from scratch
          </v-card-title>
          <v-card-subtitle class="white--text">
            Create your own custom survey from a blank template
          </v-card-subtitle>
          <v-card-actions>
            <v-btn
              color="white"
              class="primary--text mx-auto"
              @click="$emit('blank')"
            >
              Blank Template
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" sm="6">
        <v-card
          color="secondary"
          class="accent--text text-center mr-auto"
          width="400"
          height="375"
          @click="$emit('prebuilt')"
        >
          <div class="image-container">
            <v-img
              contain
              :src="$images.SURVEY_TEMPLATES"
              height="150"
              class="ma-auto"
            ></v-img>
          </div>
          <v-card-title class="d-block accent--text">
            Pick a Template
          </v-card-title>
          <v-card-subtitle>
            Get a big head start with templates our experts have built for you
          </v-card-subtitle>
          <v-card-actions>
            <v-btn color="accent" class="mx-auto" @click="$emit('prebuilt')">
              Pre-Built Template
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SurveyChooseTemplate"
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
